import { FormGroup } from '@angular/forms';
import { ChatMessage } from '../../messages/models/chat-message';
import { SalaryType } from '../../shared/models/salary-type';
export class SendProposal {
  public accountId: string;
  public coverLetter: string;
  public filePath: string;
  public salaryType: string;
  public rate: number;
  public jobId: string | null;
  public jobPosterAccountId: string;

  public static parse(form: FormGroup): SendProposal {
    let sendProposal = new SendProposal();
    Object.assign(sendProposal, form.value);
    sendProposal.rate = Number.parseInt(sendProposal.rate.toString());
    return sendProposal;
  }

  public static convertToChatMessage(proposal: SendProposal, salaryType: SalaryType): ChatMessage {
    const message = { jobid: proposal.jobId as string, 
      employerid: proposal.jobPosterAccountId, 
      candidateid: proposal.accountId, 
      message: `<b>Rate($):</b> ${proposal.rate}/${salaryType.value} <br><b>Proposal:</b><br>${proposal.coverLetter}`,
      from: "candidate", 
      time: new Date() ,
      filePath: proposal.filePath ? proposal.filePath : ""
    } as ChatMessage;
    
    return message;
  }

}
